import { i18nNsFactory } from '@atlas-frontend/i18n';
import translations from './excel.translations.json';
import { GetApiErrorMessage } from './ValidationMessagesMap';

const { addTranslations, t, exists } = i18nNsFactory(
  'excel-error-translations',
);
addTranslations(translations);

export const getExcelErrorMessage: GetApiErrorMessage = (code, meta) =>
  t(`alert.error.code.${code}`, meta?.args && { ...meta.args });

export const excelErrorExists = (code: string) =>
  exists(`alert.error.code.${code}`);
